import React from 'react'
import { List, TablePagination } from '@mui/material'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { format as formatDate, isSameDay } from 'date-fns'
import { useTheme } from '@mui/material/styles'
import { MdOutlineAttachFile } from 'react-icons/md'

const defaultLabelDisplayedRows = ({ from, to, count }) => {
  return `${from}–${to} sur ${count !== -1 ? count : `more than ${to}`}`
}

function EmailItem({ item, selectedItem, onClick }) {
  const theme = useTheme()
  const date = new Date(item.datetime)

  const dateConv = isSameDay(date, new Date()) ? formatDate(date, 'HH:mm') : formatDate(date, 'dd/MM/yyyy HH:mm')

  const handleListItemClick = () => {
    if (onClick) onClick(item)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleListItemClick()
    }
  }

  return (
    <>
      <ListItemButton
        alignItems='flex-start'
        selected={selectedItem === item.id}
        onClick={handleListItemClick}
        onKeyDown={handleKeyDown}
        sx={{
          height: 100,
          ...(item.isUnread === 1 && {
            borderLeft: '5px solid',
            borderLeftColor: theme.palette.primary.main
          })
        }}
      >
        <ListItemText
          primary={
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography
                variant='body2'
                color='text.primary'
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  flexGrow: 1
                }}
              >
                {item.fromName || item.fromEmail}
              </Typography>
              <Typography variant='body2' color='text.primary'>
                {dateConv}
              </Typography>
            </Box>
          }
          secondary={
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography
                variant='body2'
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  flexGrow: 1
                }}
              >
                {item.subject?.substring(0, 50)}
              </Typography>
              {item.attachments?.length > 0 && (
                <Typography variant='body2' color='text.primary'>
                  <MdOutlineAttachFile />
                </Typography>
              )}
            </Box>
          }
        />
      </ListItemButton>
      <Divider component='li' />
    </>
  )
}

const ListEmails = ({ emails, selected, onSelect, page, rowsPerPage, totalItem, onPageChange }) => {
  return (
    <>
      <List sx={{ width: '100%', height: '90%', bgcolor: 'background.paper' }}>
        {emails.length ? (
          emails.map((email) => (
            <EmailItem
              key={email.id}
              item={email}
              selectedItem={selected === email.id}
              onClick={() => onSelect(email.id)}
            />
          ))
        ) : (
          <div style={{ padding: '1rem' }}>No emails found</div>
        )}
      </List>
      <TablePagination
        component='div'
        rowsPerPageOptions={[]}
        count={totalItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        labelDisplayedRows={defaultLabelDisplayedRows}
      />
    </>
  )
}

export default ListEmails
